<div class = "ui-health-analysis-files-container">
    <div class = "ui-health-analysis-file-container" [style.opacity] = "sampleFile.processing ? 0.5 : 1" *ngFor = "let sampleFile of files; let i = index;"  (click) = "eventDownloadFile(i, $event)">
        <div class = "ui-panel">
            <i class = "ui-icon uii-file"></i>
        </div>
        <div class = "ui-health-analysis-file-information">
            <div class = "ui-title" [matTooltip] = "sampleFile.name" [matTooltipDisabled] = "sampleFile.name.length * 18 < 250">
                {{ sampleFile.name }}
            </div>
            <span class = "ui-sub-title">
                <span>{{ sampleFile.size | SizeFormat }}</span>
            </span>
        </div>
        <div class = "ui-health-analysis-file-extension" [ngClass] = "{
            'ui-badge-red': sampleFile.extension === 'pdf',
            'ui-badge-orange': sampleFile.extension === 'fastq',
            'ui-badge-blue': sampleFile.extension === 'wav',
            'ui-badge-purple': sampleFile.extension === 'md',
            'ui-badge-gray': sampleFile.extension === 'xml',
        }">
            <span>{{ sampleFile.extension }}</span>
        </div>
        <div class = "ui-health-analysis-upload-options">
            <i *ngIf = "!downloading.has(i)" class = "ui-text-button ui-icon uii-download" style = "transform: rotate(90deg);" matTooltip = "Baixar amostra">
            </i>
            <app-spinner *ngIf = "downloading.has(i)" type="full" width = '1.5rem' height = '1.5rem'></app-spinner>
        </div>
    </div>
    <div class = "ui-empty-container" *ngIf = "files.length === 0">
        Nenhum arquivo associado
    </div>
</div>
